module.exports = require('../../full/object/create');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/features/object/create.js
// module id = 465
// module chunks = 0 1